// extracted by mini-css-extract-plugin
export default {"menu":"menu--lGLWD","menuItem":"menuItem--W0z9r","icon":"icon--bEpkp"};